// @ts-strict-ignore
import React from 'react';
import { View } from 'react-native';
import { Box, IBoxProps } from '@styleseat/ui';
import { BrandColor, FeatureTheme } from '@styleseat/brand';
import {
  Absolute,
  BodyText,
  PortalOverlayHeaderCloseBtn,
  Stack,
  Touchable,
} from '../../../ui';
import { BasicCircleStarIcon } from '../../../ui/Icons';
import { SnackbarState } from '../../../shared/SnackbarContext';

export type ClientReferralPopoverProps = {
  onClick?: () => void;
  onClose?: () => void;
  isEmbedded?: boolean;
};

const ClientReferralPopover: React.FCWithChildren<ClientReferralPopoverProps> = ({
  onClick,
  onClose,
  isEmbedded = false,
}: ClientReferralPopoverProps) => {
  const sizingProps: IBoxProps = isEmbedded ? {} : { maxWidth: 375, paddingX: 12 };
  return (
    <Box style={{ width: '100%' }} {...sizingProps}>
      <Box>
        <Touchable onClick={onClick} testID="client-referral-popover">
          <View>
            <Stack
              space={20}
              padding={16}
              color={FeatureTheme.ClientReferralBackgroundColor}
              showBoxShadow
              alignItems="center"
            >
              <BasicCircleStarIcon
                color={FeatureTheme.ClientReferralColor}
                width={30}
                height={30}
              />
              <BodyText
                textAlign="center"
                weight="bold"
                whiteSpace="wrap"
                testID="client-referral-popover_percent-off-text"
              >
                Your friend gave 15% off (up to $50) when you discover & book a new pro
                {' '}
                <BodyText weight="bold" style={{ whiteSpace: 'nowrap' }}>
                  on StyleSeat
                </BodyText>
              </BodyText>
              <Box
                borderRadius={4}
                color={BrandColor.BackInBlack}
                paddingY={12}
                paddingX={36}
              >
                <BodyText color={BrandColor.WhiteWash} weight="bold">Explore Now</BodyText>
              </Box>
            </Stack>
          </View>
        </Touchable>
        <Absolute
          right={8}
          top={16}
        >
          <PortalOverlayHeaderCloseBtn onCloseRequest={onClose} />
        </Absolute>
      </Box>
    </Box>
  );
};

export function createClientReferralPopoverSnackbarProps({
  onClick,
  onClose,
}: ClientReferralPopoverProps): Partial<SnackbarState> {
  return {
    mainContent: (
      <ClientReferralPopover
        onClick={onClick}
        onClose={onClose}
        isEmbedded
      />
    ),
    removeFormatting: true,
  };
}

export default ClientReferralPopover;
